
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"128","height":"128"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"fill":"#FAB4CD","d":"M3.576 39.909l120.146 3.811-2.31-31.015L0 10.405z"}}),_c('path',{attrs:{"stroke":"#000","d":"M85.467 5.595l-.234 18.116M39.873 5.004l-.234 18.116M5.044 54.096h114.712M4.872 68.367H119.45M4.872 82.639H119.45M4.55 96.911h114.603"}}),_c('g',{attrs:{"stroke":"#000"}},[_c('path',{attrs:{"d":"M86.48 54.096v56.407M103.344 54.096v56.407M69.617 54.096v56.407M52.754 54.096v56.407M35.891 54.096v56.748M19.027 54.096v56.748M44.549 110.843h74.466l1.124-95.429L5.432 13.825l-.882 97.018h16.325z"}})]),_c('path',{attrs:{"fill":"#FFD250","d":"M125.935 93.051c0 16.293-13.208 29.5-29.501 29.5s-29.5-13.207-29.5-29.5c0-16.292 13.207-29.5 29.5-29.5s29.5 13.208 29.5 29.5"}}),_c('path',{attrs:{"stroke":"#000","d":"M112.499 92.368c0 9.113-7.387 16.5-16.5 16.5-9.115 0-16.5-7.387-16.5-16.5 0-9.112 7.385-16.5 16.5-16.5 9.113 0 16.5 7.388 16.5 16.5z"}}),_c('path',{attrs:{"stroke":"#000","stroke-linecap":"square","d":"M108.5 103.5L127 121"}})])])
          )
        }
      }
    